import { Tag as TagAntd } from 'antd';
import styled from 'styled-components';

export const TagEnv = styled(TagAntd)`
  position: absolute;
  top: 15px;
  margin-left: 10px;
`;
